export default {
  buttons: {
    doctor: 'Doctor Signup',
    patient: 'Patient Portal',
    header: 'Doctor Login',
  },
};
